import { MessageActions } from "../../../../../../../ngapp/src/app/message-list/state/message.actions";
angular.module('autoremind.reports.communication')
    .directive('messagingReport', ['templateService', 'messagesService', '$filter', '$timeout', 'printService', '$compile', 'eventSharingService', '$location', 'storeDowngraded', 'routeSelectorsDowngraded',
    function (templateService, messagesService, $filter, $timeout, printService, $compile, eventSharingService, $location, storeDowngraded, routeSelectorsDowngraded) {
        return {
            templateUrl: 'app/reports/communication/messages/messaging-report.html',
            restrict: 'E',
            scope: true,
            link: function (scope, elem, attr) {
                scope.print = function () {
                    var header = $filter('i18n')('_messaging_Report_');
                    var headerContents = document.getElementById('headerContent').innerHTML;
                    var innerContents = angular.element(document.getElementById('bodyContent')).clone();
                    innerContents.find('.viewColumn').remove();
                    var template = '<html><head><link rel="stylesheet" type="text/css" href="css/app.css" /></head>' +
                        '<body class="printDialog" onload="window.print(); window.close()"><h1 class="heading"> ' + header + ' </h1>' +
                        '' + headerContents + innerContents.html() + '' +
                        '</body>' +
                        '</html>';
                    var popupWindow = window.open('Print of the table', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                    popupWindow.document.open();
                    popupWindow.document.write(template);
                    popupWindow.document.close();
                };
                scope.messagesService = messagesService;
                scope.viewModel.date = {
                    from: new Date(),
                    to: new Date()
                };
                scope.viewModel.selectedMessageTypes = [];
                scope.viewModel.messagingReportIsBusy = false;
                scope.viewModel.typeOfMessages = [];
                scope.viewModel.messages = [];
                scope.viewModel.messagesStats = {
                    email: 0,
                    sms: 0,
                    smsParts: 0,
                    voice: 0,
                    total: 0
                };
                scope.viewModel.userPath = '';
                scope.viewModel.userParam = '';
                scope.multiselectSettings = {
                    displayProp: 'name',
                    idProp: 'value',
                    externalIdProp: 'name',
                    showCheckAll: false,
                    showUncheckAll: false,
                    showGroupDivider: true,
                    groupBy: 'value'
                };
                scope.multiselectcustomTexts = {
                    checkAll: 'All',
                    uncheckAll: 'Deselect all',
                    buttonDefaultText: 'Select message type',
                    dynamicButtonTextSuffix: 'message types'
                };
                scope.getMessagingReport = function () {
                    if (scope.viewModel.messagingReportIsBusy) {
                        return;
                    }
                    scope.viewModel.messagingReportIsBusy = true;
                    scope.viewModel.loadingIndicator = true;
                    messagesService.getMessagingReport(scope.viewModel.date, scope.viewModel.selectedMessageTypes)
                        .then(function (data) {
                        scope.viewModel.messagingReportIsBusy = false;
                        scope.viewModel.loadingIndicator = false;
                        if (angular.isDefined(data.messagesStats)) {
                            scope.viewModel.messagesStats = Object.assign(scope.viewModel.messagesStats, data.messagesStats);
                        }
                        if (angular.isDefined(data.messages)) {
                            var tmpMessages = [];
                            for (var i in data.messages) {
                                var isExist = false;
                                for (var x in scope.viewModel.messages) {
                                    if (scope.viewModel.messages[x].messageDataId === data.messages[i].messageDataId) {
                                        isExist = true;
                                        break;
                                    }
                                }
                                if (!isExist) {
                                    tmpMessages.push(data.messages[i]);
                                }
                            }
                            if (tmpMessages.length > 0) {
                                scope.viewModel.messages = scope.viewModel.messages.concat(tmpMessages);
                            }
                        }
                        //12/01/2015
                    }, function () {
                        scope.viewModel.messagingReportIsBusy = false;
                        scope.viewModel.loadingIndicator = false;
                    });
                };
                var _timeout = null;
                scope.filterWasChanged = function (isNoNeedTimeout) {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    if (isNoNeedTimeout) {
                        _timeout = null;
                        messagesService.messagingSorting.offset = 0;
                        scope.viewModel.messages = [];
                        scope.getMessagingReport();
                        return;
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        messagesService.messagingSorting.offset = 0;
                        scope.viewModel.messages = [];
                        scope.getMessagingReport();
                    }, 1000);
                };
                scope.$watch('viewModel.selectedMessageTypes', function (newVal, oldVal) {
                    console.log('scope.$watch', newVal, oldVal);
                    if (newVal === oldVal) {
                        return;
                    }
                    scope.filterWasChanged();
                }, true);
                scope.init = function () {
                    scope.viewModel.typeOfMessages = [];
                    var selectAll = {
                        value: 'All',
                        name: 'All categories',
                        isAll: true,
                        isMaster: true
                    };
                    scope.viewModel.typeOfMessages.push(selectAll);
                    scope.viewModel.selectedMessageTypes.push(selectAll);
                    for (var i in templateService.availableCategorys) {
                        var category = angular.copy(templateService.availableCategorys[i]);
                        if (category.value === 'enabled' || category.value === 'all') {
                            continue;
                        }
                        scope.viewModel.typeOfMessages.push(category);
                    }
                    routeSelectorsDowngraded.selectRoutesPath()
                        .subscribe(function (routeData) {
                        scope.viewModel.userPath = angular.copy(routeData.USER.path);
                        scope.viewModel.userParam = angular.copy(routeData.USER.param);
                    });
                }();
                scope.datepickers = [{ open: false }, { open: false }];
                scope.toggleDatepicker = function ($event, index) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.datepickers[index].open = !scope.datepickers[index].open;
                };
                scope.dateWasChanged = function (date) {
                    todoService.loadTasksByDay(date);
                };
                scope.dateFilter = function (date) {
                    date = new Date(date);
                    return $filter('date')(date, 'MM/dd/yyyy h:mm:ssa');
                };
                scope.mediaFilter = function (deviceId) {
                    return deviceId.substr(0, deviceId.indexOf('|'));
                };
                scope.viewMessage = function (messageId, type, messageType) {
                    console.log('viewMessage', messageId, type, messageType);
                    storeDowngraded.dispatch(MessageActions.openMessagePreviewDialogJS({
                        messageUuid: messageId,
                        mediaType: type,
                        isTrackingcode: false,
                        messageType: messageType.indexOf('reminder') ? 'autoremind' : 'communication'
                    }));
                };
                scope.changeSorting = function (column) {
                    if (messagesService.messagingSorting.sortby === column) {
                        messagesService.messagingSorting.order = !messagesService.messagingSorting.order;
                    }
                    else {
                        messagesService.messagingSorting.sortby = column;
                        messagesService.messagingSorting.order = false;
                    }
                    scope.filterWasChanged(true);
                };
                scope.lastLineInView = function (inview, inviewpart, event) {
                    console.log('inview=' + inview + ' :: ' + event);
                    if (inview) {
                        scope.getMessagingReport();
                    }
                };
                scope.convertJobCategory = function (category) {
                    var res = category;
                    var pattern = 'relation:';
                    if (category.indexOf(pattern) !== (-1)) {
                        res = category.replace(pattern, '');
                    }
                    return res;
                };
                scope.setRouteNg2 = function (personid) {
                    // Changing URL as its displaying encoded url in browser
                    $location.url(scope.getUserRouteLink(personid));
                    var params = {};
                    params[scope.viewModel.userParam] = personid;
                    eventSharingService.setRoute(scope.viewModel.userPath, params);
                };
                scope.getUserRouteLink = function (personId) {
                    return scope.viewModel.userPath + '?' + scope.viewModel.userParam + '=' + personId;
                };
                scope.isInIframe = window.self !== window.top;
            }
        };
    }]);
//# sourceMappingURL=messaging-report.directive.js.map